/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return CostFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<CostFeatureFlagsWithDefaults>): CostFeatureFlagsWithDefaults {
        let obj = Object.assign(new CostFeatureFlagsWithDefaults(), model);
        CostFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostFeatureFlagsWithDefaults>): CostFeatureFlagsWithDefaults {
        if (!model) return null;
        return CostFeatureFlagsWithDefaults.newInstance(<CostFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.CostFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    cost_2601_f_budget_trend_widget: boolean = true;

    /**
     * Flag's default value
     */
    cost_2601_b_flush_balance_verification: boolean = false;

    /**
     * Flag's default value
     */
    cost_2504_b_trend_observability: boolean = false;

    /**
     * Flag's default value
     */
    cost_2602_f_cost_trend_hide_variance: boolean = true;

    /**
     * Flag's default value
     */
    cost_2602_a_billing_inventory_resource_tags: boolean = true;

    /**
     * Flag's default value
     */
    cost_2602_f_oci_compartment_based_cost_121002: boolean = true;

    /**
     * Flag's default value
     */
    cost_2602_b_dimension_grouping_rule_conflict_resolution_119664: boolean = false;

    /**
     * Flag's default value
     */
    cost_2602_f_summary_cloud_plus_k8_cost_spend_widget: boolean = false;

    /**
     * Flag's default value
     */
    cost_2602_b_savings_plans_external_api: boolean = true;

    /**
     * Flag's default value
     */
    cost_2603_a_allow_cost_usage_api_more_than_31_days: boolean = false;

    /**
     * Flag's default value
     */
    cost_2604_a_finops_for_ai: boolean = true;

    /**
     * Flag's default value
     */
    cost_2604_a_finops_for_ai_anthropic: boolean = false;

    /**
     * Flag's default value
     */
    cost_2606_a_finops_for_ai_azure: boolean = false;

    /**
     * Flag's default value
     */
    cost_2606_f_variance_pct_sort: boolean = true;

}
